const FONT_FAMILY =
  process.env.REACT_APP_FONT_FAMILY ||
  'SF Pro Display, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const typography = {
  fontFamily: FONT_FAMILY,
  fontSize: {
    xs: 11,
    sm: 13,
    base: 14,
    lg: 18,
    xl: 20,
    "2xl": 24,
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
  },
  lineHeight: 22 / 14,
};

export const colors = {
  primary: {
    50: "#F3FAF1",
    100: "#E3F3DE",
    200: "#C7E7BC",
    300: "#AADA99",
    400: "#7CCF66",
    500: "#4AA02C",
    600: "#3E8A25",
    700: "#2F6B1D",
    800: "#204C14",
    900: "#10260A",
  },

  warning: "#F59E0B",
  error: "#DC2626",
  info: "#2563EB",

  neutral: {
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#E5E5E5",
    300: "#D4D4D4",
    400: "#A3A3A3",
    500: "#737373",
    600: "#525252",
    700: "#404040",
    800: "#262626",
    900: "#171717",
  },
};

export const semantic = {
  colorPrimary: colors.primary[500],
  colorPrimaryHover: colors.primary[600],
  colorPrimaryActive: colors.primary[700],
  colorPrimaryLight: colors.primary[100],
  colorPrimaryBg: colors.primary[50],

  colorSuccess: colors.primary[500],
  colorWarning: colors.warning,
  colorError: colors.error,
  colorInfo: colors.info,

  sidebarBg: colors.primary[900],
  sidebarActiveItemBg: "rgba(74, 160, 44, 0.15)",
  sidebarActiveText: colors.primary[300],

  loginGradient: `linear-gradient(135deg, ${colors.primary[500]} 0%, ${colors.primary[700]} 100%)`,

  chartTotal: colors.primary[500],
  chartPending: colors.warning,
  chartProcessed: colors.primary[400],

  statFeedback: colors.primary[500],
  statAppointment: colors.primary[400],
  statNews: colors.info,
  statOfficers: colors.primary[600],

  chatUserBubble: colors.primary[500],
  chatUserBubbleLight: colors.primary[50],
  chatBotAvatar: colors.primary[400],
  chatBotBubbleLight: colors.primary[50],
};

export const antdTheme = {
  token: {
    colorPrimary: colors.primary[500],
    colorError: colors.error,
    colorWarning: colors.warning,
    colorInfo: colors.info,
    colorSuccess: colors.primary[500],
    borderRadius: 10,
    fontFamily: FONT_FAMILY,
    fontSize: typography.fontSize.base,
    fontSizeSM: typography.fontSize.xs,
    fontSizeLG: typography.fontSize.lg,
    lineHeight: typography.lineHeight,
    fontWeight: typography.fontWeight.medium,
    fontWeightStrong: typography.fontWeight.semibold,
  },
  components: {
    Card: {
      borderRadiusLG: 12,
      headerFontSize: typography.fontSize.base,
      headerFontSizeSM: typography.fontSize.sm,
    },
    Button: {
      borderRadius: 10,
      fontSize: typography.fontSize.base,
      fontWeight: typography.fontWeight.medium,
    },
    Modal: {
      borderRadiusLG: 12,
      titleFontSize: typography.fontSize.base,
    },
    Menu: {
      fontSize: typography.fontSize.sm,
      itemMarginInline: 8,
    },
    Table: {
      headerBg: colors.neutral[50],
      fontSize: typography.fontSize.sm,
    },
    Form: {
      labelFontSize: typography.fontSize.sm,
    },
    Typography: {
      titleMarginBottom: 0,
    },
    Tabs: {
      titleFontSize: typography.fontSize.sm,
    },
    Statistic: {
      titleFontSize: typography.fontSize.sm,
      contentFontSize: typography.fontSize["2xl"],
    },
  },
};
